

import { EvidenciaBean } from './evidenciaBean.model';
import { Base } from '../core/base.model';
import { Usuario } from '../security/usuario.model';
import { VersionBean } from './version.model';


export class incidenciaDetalleQABean extends Base{
     id: number;
     descripcion: string;
     evidencia: string;
     /** Ids de versión en texto: UUID de Mongo, el id numérico de cos_version o el centinela PENDIENTE_VERSION (T3b). */
     id_version_incidencia: string;
     id_version_resuelto: string;
     fecha_creacion: string;
     id_usuario_autor: number;
     id_incidencia: number;
     origen_cliente: string;

     versionResueltoBean: VersionBean;
     versionDetectadoBean: VersionBean;
     usuarioBean: Usuario;
     evidenciaBean: EvidenciaBean;
     listaEvidenica: Array<EvidenciaBean>;

     id_emp_asignado: number;
     id_emp_reasignado: number;

     nombre_emp_asignado: string;
     nombre_emp_reasignado: string
}